import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { EConsumptionActions, GetConsumption, GetConsumptionSuccess, GetConsumptionFailure } from '../actions/consumption.actions';
import { LinesService } from '../../services/lines.service';
import { ConsumptionInterface } from '../../models/consumption.interface';
import { Store} from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractEffects } from '../../../shared/abstract.effects';

@Injectable()
export class ConsumptionEffects extends AbstractEffects {

    phoneNumber: string = null;

    constructor(
      private actions: Actions,
      private lineService: LinesService,
      public override store: Store<any>
    ) {
        super(store);
    }

    getConsumption = createEffect(() => this.actions.pipe(
        ofType<GetConsumption>(EConsumptionActions.GetConsumption),
        tap(params => { this.phoneNumber = params.phoneNumber; }),
        switchMap(() => this.lineService.getPhoneNumberConsumption(this.phoneNumber)),
        switchMap((response: ConsumptionInterface) => of(new GetConsumptionSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetConsumption(this.phoneNumber));
            } else if (error.error['error_message'] !== 'invalid_customer_phone_number') {
                this.DisplayMessage('error_with_retry', 400, new GetConsumptionFailure());
            } else {
                this.store.dispatch(new GetConsumptionFailure());
            }
            return throwError(error);
        })
    ));
}
